import { render, staticRenderFns } from "./PersonalNoteForm.vue?vue&type=template&id=2f2252e9&"
import script from "./PersonalNoteForm.vue?vue&type=script&lang=js&"
export * from "./PersonalNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./PersonalNoteForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports